import { style } from 'typestyle'
export const pt8 = style({ paddingTop: '8px' })
